// extracted by mini-css-extract-plugin
export default {"buttons":"deleteMenu_buttons__LyDVV","closeBtn":"deleteMenu_closeBtn__40H40","save":"deleteMenu_save__Dt8hu","close":"deleteMenu_close__Voyop"};